import { Badge } from "antd";
import filterData from "./src/filterData";

function FilterHeader({ activeFilter, processActiveFilter, chipCounts = {} }) {
  return (
    <div className="notifs-extra-filters">
      {filterData.map((el) => {
        const active = el.id === activeFilter;
        const count = chipCounts[el.id] || 0;
        const icon = (
          <el.Icon fill={active ? el.color2 : el.color} />
        );
        return (
          <span
            className={`filter-btn${active ? " is-active" : ""}`}
            key={el.id}
            onClick={() => processActiveFilter(el.id)}
            style={active ? { color: el.color2 } : undefined}
            title={el.title}
          >
            {count > 0 ? (
              <Badge
                size="small"
                count={count}
                offset={[6, -4]}
                color={el.color2}
              >
                {icon}
              </Badge>
            ) : (
              icon
            )}
            {el.title}
          </span>
        );
      })}
    </div>
  );
}

export default FilterHeader;
